/*****************************************************************************************************************************************************
 * Revision History
 * 2024-12-16 TBH - Added htmlAddress property set by Address.HtmlAddress.
 * 2025-01-09 TBH - BUG FIX. Typo in bindConfirmationList() checking for null response. Had "if( respone == undefined ) {".
 *****************************************************************************************************************************************************/
export default function basketCartConfirmation() {
  return {
    candidacyDetails: '',
    isSucess:false,
    balancePaymentDetails: [],
    certificateDetails: [],
    transcriptDetails: [],
    verificationDetails: [],
    baskettCartConfirmationDetails:[],
    baskettCartConfirmationDetailsInfo: [],
    curriculumExtendedInfoLiteral: "", 
    requestType: '',
    msg: '',    
    showErrorMesage: "",
    message: "Loading information please wait...",
    showLoader: false,
    total_Amount: 0,
    currentFormattedDate: '',
    confirmationMessage: '',
    paymentReceiptNumber: '',
    referenceNumber: '',
    entryDate: '',
    dupCertLiteral:'',
    people: '',
    address: '',            
    htmlAddress: '',
      
    formatDate( dateValue ) {
      const options = { month: "short", day: "numeric" };
      const formattedDate = new Date( dateValue ).toLocaleDateString( undefined, options );
      return( formattedDate );
      },

    bindConfirmationList() {
// // console.log( 'GetBasketConfirmation()' );
      this.showLoader = true;
      this.waitlistCartList = [];
      this.enrollmentCartList = [];
      fetch( "/api/basket/GetBasketConfirmation", {
         method: "get"
      , headers: {
          Accept: "application/json"
        , "Content-Type": "application/json"
        }
      }).then(( response ) => {
        return( response.json());
      }).then(( response ) => {
        this.showLoader = false;
        this.isSucess = response.isSuccess;
        if( response == undefined ) {
          this.mesage = "Failed to get response.";
        } else if( !response.isSuccess ) {
          this.message = response.messages.length > 0 ? response.messages.join(', ') : response.message;
        } else {
          this.baskettCartConfirmationDetails = response;
          this.addressDetails = response.address;                // Not used.
          this.people = response.people;

// console.log( 'response: ' + JSON.stringify( response ));  // returns response as JSON.
          if( response.candidacyDetails != null ) {
// console.log( 'candidacyDetails.requestType : ' + response.requestType );
            this.baskettCartConfirmationDetailsInfo = response.candidacyDetails;
            this.curriculumExtendedInfoLiteral = "<p>Requests will be processed within 1-2 weeks."
            this.requestType = "CandidacyRequests";
            if( response.candidacyDetails.showRequestForCertificateText ) {
              this.curriculumExtendedInfoLiteral = this.curriculumExtendedInfoLiteral + "  Please note that the Request for Certificate (<a class='text-primary underline font-medium' target='_blank'  href='/my-account/my-certificates/request-for-certificate'> Request for certificate</a>) must also be submitted during the final course of your program to receive your certificate."
            }
            this.curriculumExtendedInfoLiteral = this.curriculumExtendedInfoLiteral + "</p>"

          } else if( response.certificateDetails != null ) {
            this.requestType = "CertificateRequests";
            if( response.certificateDetails.paperDomestic ) {
              this.msg = "Address Details:<br/>"; 
              this.msg += response.certificateDetails.address.htmlLabel;
            } else if( response.certificateDetails.digitalCertificate && response.certificateDetails.shippingCode =='' ) {
              this.msg = "Digital Copy sent to: ";
              this.msg += response.certificateDetails.email;
            } else if( response.certificateDetails.shippingCode != '') {
              this.msg = "Request will be processed once shipping label is created by student on UEMS.<br/>";
              let pdflink = document.getElementById("pdfLink")?.value;
              this.msg += "Click for instructions on how to create the label: <a href='" + pdflink + "'class='text-primary underline font-medium' target='_blank'>How to create a shipping label for your paper certificate</a>.<br/>";
              this.msg += "<ol class='list-decimal ml-5'>";
              this.msg += "<li>Create an account on the UEMS webpage: <a href='https://study.eshipglobal.com/' class='text-primary underline font-medium' target='_blank'>https://study.eshipglobal.com/</a></li>";
              this.msg += "<li>Choose from the available delivery options</li>";
              this.msg += "<li>Pay for Shipping</li>";
              this.msg += "</ol>";
            }
            this.baskettCartConfirmationDetailsInfo = response.certificateDetails;

          } else if (response.transcriptDetails != null) {
            this.requestType = "TranscriptRequests";
            this.baskettCartConfirmationDetailsInfo = response.transcriptDetails;

          } else if (response.verificationDetails != null) {
            this.curriculumExtendedInfoLiteral = "<p>"
            this.requestType = "VerificationRequests";
            this.msg = response.message; 
            this.baskettCartConfirmationDetailsInfo = response.verificationDetails;

          } else if( response.balancePaymentDetails != null ) {
            this.requestType = "BalancePaymentRequests";
            this.baskettCartConfirmationDetailsInfo = response.balancePaymentDetails;
          }
// console.log( 'setTimeout' );
          setTimeout( function () {
            fetch( "/api/basket/EndConfirmation", {
              method: "get"
            , headers: {
                Accept: "application/json"
              , "Content-Type": "application/json",
              }
            }).then(( response ) => {
              return( response.json());
            }).then(( response ) => {
              if( response ) {
                console.error( 'EndConfirmation - Failed to get response.' );
              } else if( !response.isSuccess ) {
                console.error( 'EndConfirmation - Not successul:' + response.message + '.' );
              } else {
// console.log( 'EndConfirmation complete.' );
              }
            });
          }, 1500 );
        }
      });
    },

    init() {
      this.currentFormattedDate = new Date().toLocaleDateString();
      this.bindConfirmationList();
    },
  };
}
